<template>
  <div class="common-index">
    <!-- <create-dialog
      v-model="dialog"
      @CloseDialog="dialog = { state: false, item: undefined }"
      :item="item"
      @fetch="fetchData"
    ></create-dialog> -->
    <v-card class="rounded-xl" flat>
      <v-card-title class="text-h6 font-weight-bold py-6" >
        <v-icon color="green" class="mr-2">mdi-chevron-right</v-icon>
        {{ title || '' }}
        
        <slot name="preTitle" :reload="fetchData"></slot>
        <span class="ml-2"></span>
        
        <v-spacer></v-spacer>
        <slot name="action2" :reload="fetchData"></slot>
        <slot name="action1" :reload="fetchData"></slot>
        <v-divider vertical class="mx-4 d-none d-sm-block" v-if="title"></v-divider>
        <!-- <v-spacer></v-spacer> -->
        <!-- <v-btn icon color="green" class="mx-2" @click="fetchData">
          <v-icon>mdi-refresh</v-icon>
        </v-btn> -->
        
        <div class="d-flex align-center wrapper mr-2 my-1" v-if="importHandler">
          <v-btn outlined @click="importDialog=true" color="green lighten-3" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
            <v-icon color="green darken-4">mdi-import</v-icon>
          </v-btn>
          <v-dialog v-model="importDialog" width="600px">
            <v-card>
              <v-card-title class="text-subtitle-1">
                Import file excel
              </v-card-title>
              <v-card-subtitle v-if="importSubtitle">
                {{ importSubtitle }}
              </v-card-subtitle>
              <v-card-text>
                <slot name="importSection" :reload="fetchData" :importData = "importData"></slot>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn color="red" @click="importDialog=false" outlined style="text-transform: none;">Cancel</v-btn>
                <v-btn color="green" @click="handlerImport" dark style="text-transform: none;">Import</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <export-excel :textStyle="true" :items="items" :headers="headers" :file-name="title" :buttonStyle="enableCreate ? 'outlined': 'bold'"></export-excel>
        
        <v-btn
          v-if="enableCreate"
          @click="openDialog()"
          color="teal darken-4"
          style="text-transform: none"
          dark large
          class="ml-2 rounded-lg"
        >
          <v-icon left>mdi-plus</v-icon>
          Tạo mới
        </v-btn>
      </v-card-title>
      <v-sheet>
        <index-filter
          :filters="filters"
          :month="month"
          :dateFrom = "dateFrom"
          :dateTo = "dateTo"
          @refresh="fetchData"
          @changeMonth="handleMonthChange"
          @changeDateFrom="handleDateFromChange"
          @changeDateTo="handleDateToChange"
          :monthDisabled="monthDisabled"
          :fromTo="fromTo"
        ></index-filter>
      </v-sheet>
      <v-data-table
        :dense="dense"
        height="calc(100vh - 300px)"
        fixed-header
        :headers="headers"
        :items="items"
        :loading="isLoading"
        :group-by="groupBy"
        loading-text="Đang tải dữ liệu..."
        :items-per-page="itemsPerPage"
        :footer-props="{
          // itemsPerPage: '',
          itemsPerPageOptions: [50, 100, 200, -1]
        }"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon small @click="openDialog(item)" color="info">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
          <!-- deleteHandler(item[tableKey]) -->
          <v-btn v-if="deleteHandler" icon small @click="dialogDelete=true, targetItem=item" color="error">
            <v-icon>mdi-trash-can</v-icon>
          </v-btn>
        </template>
        <template v-for="cellSlot in cellSlots" v-slot:[`item.${cellSlot}`]="{ item }">
          <slot :name="cellSlot" :cell="item" :reload="fetchData"></slot>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-subtitle-1">Bạn có chắc muốn xoá dữ liệu này? ID: {{ targetItem?.id }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-2" @click="dialogDelete = false" style="text-transform: none;" outlined>Thoát </v-btn>
          <v-btn color="red darken-1" dark @click="cfmDeleteItem">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <view-dialog ref="view_dialog" :width="detailWidth" 
    :showActions="showActions" 
    :updateHandler="updateHandler"
    :createHandler="createHandler"
    @reload="fetchData">
      <template #viewSection="{ item, onInput, mode }">
        <slot name="viewSection" :item="item" :onInput="onInput" :mode="mode"></slot>
      </template>
    </view-dialog>
  </div>
</template>

<script>
import * as moment from 'moment/moment';
import IndexFilter from './IndexFilter';
import ViewDialog from './ViewDialog';
import ExportExcel from '@/components/ExportExcel';

export default {
  name: 'IndexView',
  components: {
    IndexFilter,
    ViewDialog,
    'export-excel': ExportExcel
  },
  props: {
    dense: {
      type: Boolean,
      default: true
    },
    tableKey: {
      type: String,
      default: 'id'
    },
    groupBy: {
      type: String,
      default:null
    },
    itemsPerPage: {
      type: Number,
      default:-1
    },
    filters: {
      type: Array,
      default: () => []
    },
    month: {
      type: String,
      default: () => moment().startOf('months').format('YYYY-MM-DD')
    },
    monthDisabled: {
      type: Boolean,
      default: false
    },
    fromTo: {
      type: Boolean,
      default: false
    },
    dateFrom: {
      type:[Date,String],
      default: () => moment().startOf('months').format('YYYY-MM-DD') 
    },
    dateTo: {
      type:Date,
      default: () => moment().endOf('months').format('YYYY-MM-DD')
    },
    title: {
      type: String,
      default: ''
    },
    headers: {
      type: Array,
      required: true
    },
    cellSlots: {
      type: Array,
      default: () => []
    },
    detailWidth: {
      type: [String, Number],
      default: '600px'
    },
    enableCreate: {
      type: Boolean,
      default: false
    },

    showActions: {
      type: Boolean,
      default: false
    },
    
    getData: {
      type: Function,
      required: true
    },
    getDetail: {
      type: Function,
      required: true
    },
    
    importHandler: {
      type: Function,
      required: false
    },
    importSubtitle:{
      type:String,
      required: false
    },
    deleteHandler: {
      type: Function,
      default: null
    },
    createHandler: {
      type: Function,
      default: null
    },
    updateHandler: {
      type: Function,
      default: null
    }
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.item = null;
      }
    },
    filters: {
      handler() {
        this.tableParams.page = 1;
      },
      deep: true
    },
    month() {
      this.fetchData();
    }
  },
  data() {
    return {
      importDialog: false,
      importData: {},
      tableParams: {
        sortBy: [],
        sortDesc: [],
        page: 1,
        pageSize: 10000
      },
      items: [],
      isLoading: false,
      dialog: {
        state: false,
        item: undefined
      },
      item: null,
      dialogDelete: false,
      targetItem: undefined
    };
  },
  methods: {
    handleMonthChange(month) {
      this.$emit('update:month', month);
      this.month = month
      this.fetchData();
    },
    
    handleDateFromChange(value) {
      this.$emit('update:dateFrom', value);
      this.dateFrom = value
      this.fetchData();
    },
    
    handleDateToChange(value) {
      this.$emit('update:dateTo', value);
      this.dateTo = value
      this.fetchData();
    },
    handlerImport() {
      const formData = new FormData();

      Object.entries(this.importData).forEach(([key, value]) => {
        formData.append(key, value);
      });
      return this.importHandler(formData).then(() => this.fetchData())
    },
    openDialog(item) {
      if (!item) {
        this.$refs.view_dialog.open();
        return;
      }
      const key = item[this.tableKey];
      this.getDetail(key)
        .then(res => {
          this.$refs.view_dialog.open(res.data, key);
        })
        .catch(err => {
          console.error('Error fetching detail:', err);
        });
    },
    async fetchData() {
      this.isLoading = true;
      try {
        if(this.monthDisabled) {
          const response = await this.getData(this.dateFrom, this.dateTo);
          this.items = response.data;
          console.log('Fetched data:', this.items);
        }else {
          const response = await this.getData(this.month);
          this.items = response.data;
          console.log('Fetched data:', this.items);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      } finally {
        this.isLoading = false;
      }
    },
    remove(item) {
      this.dialogDelete = true;
      this.targetItem = item;
    },
    async cfmDeleteItem() {
      if (!this.targetItem) return;
      try {
        if (this.deleteHandler) {
          await this.deleteHandler(this.targetItem[this.tableKey]);
        } else {
          console.warn('No deleteHandler provided for IndexView');
        }
        const deletedItem = this.targetItem;
        this.fetchData();
        this.dialogDelete = false;
        this.targetItem = undefined;
        this.$emit('deleted', deletedItem);
      } catch (err) {
        console.error('Error deleting item:', err);
      }
    },
    inputHandler(value) {
        this.$refs.view_dialog.setItem(value);
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>